import React from "react";
import { AdminKpiCard } from "../ui";

export type SubscriptionKpiGridProps = {
  abonnementsActifs: number;
  clientsSansAbonnement: number;
  sansPlanning: number;
  impayesAbonnements: number;
  revenuMensuelLabel: string;
  revenuMensuelHint?: string;
};

export function SubscriptionKpiGrid(props: SubscriptionKpiGridProps): React.JSX.Element {
  const {
    abonnementsActifs,
    clientsSansAbonnement,
    sansPlanning,
    impayesAbonnements,
    revenuMensuelLabel,
    revenuMensuelHint,
  } = props;

  return (
    <section className="grid grid-cols-2 gap-3 lg:grid-cols-5">
      <AdminKpiCard label="Abonnements actifs" value={String(abonnementsActifs)} />
      <AdminKpiCard label="Clients sans abonnement" value={String(clientsSansAbonnement)} />
      <AdminKpiCard
        label="Abonnements sans planning"
        value={String(sansPlanning)}
        hint="Sans prochain passage ni passages prévus renseignés"
      />
      <AdminKpiCard
        label="Impayés (abonnements actifs)"
        value={String(impayesAbonnements)}
        hint="Contrats actifs avec solde client > 0"
      />
      <AdminKpiCard label="Revenus mensuels estimés" value={revenuMensuelLabel} hint={revenuMensuelHint} />
    </section>
  );
}
